import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../../components/header/Header";
import SectionChip from "../../ReuseableComponents/rag/SectionChip";
import { ragConcept } from "../../service/ragSearch";

// Topic page behind a concept card: definition, related topics, and the
// salience-ranked classes that teach the concept.
export default function ConceptPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let active = true;
    setStatus("loading");
    setData(null);
    ragConcept(slug)
      .then((d) => {
        if (active) {
          setData(d);
          setStatus("ok");
        }
      })
      .catch(() => {
        if (active) setStatus("error");
      });
    return () => {
      active = false;
    };
  }, [slug]);

  return (
    <div>
      <Header />
      <div className="max-w-5xl mx-auto px-4 py-8">
        {status === "loading" && (
          <div className="flex justify-center py-10 text-primaryDark">Loading…</div>
        )}
        {status === "error" && (
          <div className="flex justify-center py-10 text-primaryDark">
            Topic not found
          </div>
        )}
        {status === "ok" && data && (
          <>
            <div className="rounded-lg border border-primaryBlue bg-primaryBlue bg-opacity-[0.06] p-4 mb-8">
              <h1 className="text-2xl md:text-3xl font-extrabold text-primaryDark">
                {data.concept.name}
              </h1>
              {data.concept.definition ? (
                <p className="mt-2 text-primaryDark">{data.concept.definition}</p>
              ) : null}
              {(data.related || []).length > 0 && (
                <div className="mt-3 flex flex-wrap gap-2">
                  {data.related.map((r) => (
                    <Link
                      key={r.slug}
                      to={`/concept/${r.slug}`}
                      className="rounded-full border border-primaryBlue text-primaryBlue text-sm px-3 py-1 hover:bg-primaryBlue hover:text-white transition"
                    >
                      {r.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <h2 className="text-[22px] md:text-2xl font-extrabold text-primaryDark mb-4">
              {`Classes on ${data.concept.name}`}
            </h2>
            <div className="space-y-4">
              {(data.classes || []).map((c) => (
                <Link
                  key={c.class_id}
                  to={`/${c.permalink ?? c.class_id}`}
                  className="block rounded-lg bg-[#D2D6DC] bg-opacity-[0.4] p-4 hover:bg-opacity-[0.6] transition"
                >
                  <div className="flex items-center gap-2">
                    <SectionChip section={c.section} />
                    <span className="font-bold text-primaryDark">{c.title}</span>
                  </div>
                  {c.match_reason ? (
                    <p className="mt-1 text-sm font-semibold text-primaryBlue">
                      {c.match_reason}
                    </p>
                  ) : null}
                  {c.summary ? (
                    <p className="mt-1 text-sm text-primaryDark">{c.summary}</p>
                  ) : null}
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
